import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { STATUS_COLORS } from "shared/constants";
import "./StudentGridCell.scss";
import "./NationalStudentGridCell.scss";
import { StudentPsiStatus, PsiStudentDetailsModal } from "../index";

const NationalStudentGridCell = (props) => {
  const { cellData, setLastFetchTime, isAutoRefreshStarted, isUpdateStatus } =
    props;
  const [isOpen, setIsOpen] = useState(false);
  const [cellDataValue, setCellDataValue] = useState(cellData);
  const status = cellDataValue?.status || null;
  const hasPendingStatus = status?.includes("pending");
  const ref = useRef();

  useEffect(() => {
    if (cellData) {
      ref.current = cellData;
    }
  }, [cellData]);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isAutoRefreshStarted || isUpdateStatus) {
      setCellDataValue(ref.current);
    }
  }, [isAutoRefreshStarted, isUpdateStatus]);

  if (!cellDataValue) {
    return <div className="cell national-student-cell empty"></div>;
  }

  return (
    <div className={`cell national-student-cell `}>
      <div
        className={`national-name-section  ${
          hasPendingStatus ? "" : STATUS_COLORS[status]
        }`}
        tabIndex="0"
        onClick={toggleModal}
      >
        <div className="fw-bold">{cellDataValue?.lastName},</div>
        <div className="fw-bold">{cellDataValue?.firstName}</div>
        <div>{cellDataValue?.sectionFormName || "-"}</div>
      </div>
      <StudentPsiStatus
        cellData={cellDataValue}
        smallIcon={hasPendingStatus}
        setLastFetchTime={setLastFetchTime}
      />
      <PsiStudentDetailsModal
        id={cellDataValue?.regId}
        isOpen={isOpen}
        handleClose={toggleModal}
      />
    </div>
  );
};

NationalStudentGridCell.propTypes = {
  cellData: PropTypes.shape({
    status: PropTypes.string,
    lastName: PropTypes.string,
    firstName: PropTypes.string,
    sectionFormName: PropTypes.string,
    regId: PropTypes.number,
  }),
  setLastFetchTime: PropTypes.func,
  isAutoRefreshStarted: PropTypes.bool,
  isUpdateStatus: PropTypes.bool,
};

export default NationalStudentGridCell;
